<script lang="ts" setup>
import config from '~~/config.json'
const date = useState('date', () => new Date())
</script>

<template>
  <div class="m-footer">
    <div class="m-footer__container">
      <div class="m-footer__links">
        <div class="m-footer__section">
          <m-text type="light-primary">
            <m-icon icon="icon lucide-pencil-ruler" gap>创作中心</m-icon>
          </m-text>
          <div class="content">
            <m-link size="14px" to="/create/feed">发布动态</m-link>
            <m-link size="14px" to="/create/article">文章投稿</m-link>
            <m-link size="14px" to="/create/video">视频投稿</m-link>
            <m-link size="14px" to="/create">创作活动</m-link>
          </div>
        </div>
        <div class="m-footer__section">
          <m-text type="light-primary">
            <m-icon icon="icon lucide-info" gap>关于我们</m-icon>
          </m-text>
          <div class="content">
            <m-link
              size="14px"
              to="https://resource.mfuns.net/imgs/license/business-license.png"
            >
              营业执照
            </m-link>
            <m-link
              size="14px"
              to="https://www.mfuns.net/agree/userAgreement.html"
            >
              用户协议
            </m-link>
            <m-link size="14px" to="https://www.mfuns.net/agree/priv.html">
              隐私协议
            </m-link>
            <m-link size="14px" to="https://www.mfuns.net/doc/audit.html">
              审核规范
            </m-link>
          </div>
        </div>
        <div class="m-footer__section">
          <m-text type="light-primary">
            <m-icon icon="icon lucide-flag" gap>举报中心</m-icon>
          </m-text>
          <div class="content">
            <m-link size="14px" to="/report/bad">不良信息举报</m-link>
            <m-link size="14px" to="/report/plagiarism">侵权抄袭举报</m-link>
            <m-link size="14px" to="/report/teen">涉未成年举报</m-link>
            <m-link
              noseo
              size="14px"
              to="http://www.shdf.gov.cn/shdf/channels/740.html"
            >
              扫黄打非举报
            </m-link>
          </div>
        </div>
        <div class="m-footer__section">
          <m-text type="light-primary">
            <m-icon icon="icon lucide-headphones" gap>客服中心</m-icon>
          </m-text>
          <div class="content">
            <m-link size="14px" to="/customer/contact">联系客服</m-link>
          </div>
        </div>
      </div>
      <div class="m-footer__imgs">
        <m-link noseo size="12px" to="http://www.shjbzx.cn">
          <NuxtImg
            src="https://resource.mfuns.net/imgs/license/shjbzx.png"
            class="lic-img"
            alt="上海市互联网违法和不良信息举报中心"
          />
        </m-link>
        <m-link noseo size="12px" to="https://www.12377.cn">
          <NuxtImg
            src="https://resource.mfuns.net/imgs/license/12377.png"
            class="lic-img"
            alt="中国互联网违法和不良信息举报中心"
          />
        </m-link>
        <m-link noseo size="12px" to="https://gaj.sh.gov.cn">
          <NuxtImg
            src="https://resource.mfuns.net/imgs/license/962110.png"
            class="lic-img"
            alt="全国反诈专线"
          />
        </m-link>
      </div>
      <div class="m-footer__copyright">
        <div>
          <m-link to="https://www.mfuns.net/sitemap.xml">站点地图</m-link>
        </div>
        <div>
          增值电信业务经营许可证
          <m-link noseo to="https://tsm.miit.gov.cn/dxxzsp/">
            沪B2-20250623
          </m-link>
        </div>
        <div>
          互联网ICP备案 |
          <m-link noseo to="https://beian.miit.gov.cn"
            >沪ICP备2022032900号</m-link
          >
        </div>
        <div>
          网上有害信息举报专区 |
          <m-link noseo to="https://www.12377.cn/"
            >中国互联网违法和不良信息举报中心</m-link
          >
        </div>
        <div>
          友情链接 :
          <m-link to="https://firebook.store/api/info/share"> 炎上书屋 </m-link>
          <m-link to="https://thfmu.com/"> 东方医学 </m-link>
        </div>
        <div>
          Copyright &copy; 2020-{{
            date.getFullYear()
          }}
          上海喵御宅网络科技有限公司 保留所有权利 版本：{{ config.version }}
        </div>
      </div>
      <img
        class="miao"
        src="https://resource.mfuns.net/imgs/miao.webp"
        alt="喵奈"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-footer {
  width: 100%;
  height: 500px;
  background-color: #4f3f61;
  justify-content: center;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  color: white;
  a {
    color: var(--color-gray-200);
  }
  a[href]:hover {
    color: var(--color-primary-300);
  }
  &__container {
    margin-top: 24px;
    width: 100%;
    min-width: 460px;
    max-width: min(80%, 1820px);
  }

  .miao {
    width: 400px;
    position: absolute;
    right: 20px;
    bottom: 0;
  }
  &__links {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
  }
  &__section {
    border-radius: 4px;
    min-height: 20px;
    width: 200px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    .content {
      display: flex;
      flex-direction: column;
      margin-top: 12px;
      > * {
        margin: 4px 0;
      }
    }
  }
  &__imgs {
    display: flex;
    flex-wrap: wrap;

    .lic-img {
      height: 50px;
    }
    > * {
      margin-right: 8px;
    }
  }
  &__copyright {
    display: flex;
    flex-direction: column;
    > * {
      margin: 8px 0;
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1280px) {
  .m-footer {
    height: fit-content;
    &__container {
      min-width: unset;
    }
    .miao {
      display: none;
    }
  }
}

@media screen and (max-width: 600px) {
  .m-footer {
    height: fit-content;
    &__container {
      width: 100vw !important;
      min-width: unset;
    }
    &__links {
      flex-direction: column;
    }
    .miao {
      display: none;
    }
  }
}
</style>
